// automatically generated by the FlatBuffers compiler, do not modify

export enum Direction {
  Up = 0,
  Down = 1,
  Left = 2,
  Right = 3,
  Idle = 4,
  Unknown = 5
}
